import { render } from "./base-layout.vue?vue&type=template&id=da83cf08&ts=true"
import script from "./base-layout.vue?vue&type=script&lang=ts"
export * from "./base-layout.vue?vue&type=script&lang=ts"

import "./base-layout.vue?vue&type=style&index=0&id=da83cf08&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__